import React, { useState } from "react";
import Card from "components/card";
import { readUser } from "utils/session";
import AccountImage from "components/AccountImage";
import { changeOwnPassword } from "utils/orgApi";

const fieldClass =
  "w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm text-navy-700 dark:border-white/10 dark:bg-navy-900 dark:text-white";

function Profile() {
  const loc = readUser() || {};
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const {
    accountType,
    branchAddr,
    branchName,
    customerName,
    userContact,
    zoneName,
  } = loc;

  const savePassword = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("The new passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await changeOwnPassword({ currentPassword, newPassword });
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setMessage("Password changed");
    } catch (err) {
      setError(err.message || "The password was not changed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <Card
        extra="!flex-row flex-grow items-center justify-center rounded-[6px] h-[200px] mt-5 relative shadow-md"
        style={{ padding: "150px" }}
      >
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col items-center gap-3 text-blue-1000">
            <AccountImage
              alt="User Profile"
              className="mb-5 h-[60px] w-[60px] rounded-full object-cover"
            />
            <h2 className="text-2xl font-semibold">{customerName}</h2>
            <h3 className="font-semibold">
              {accountType} - {branchName}, Zone - {zoneName}
            </h3>
          </div>
          <div className="text-center">
            <p className="font-medium text-gray-600 mb-3">{userContact}</p>
            <p className="font-medium text-gray-600">{branchAddr}</p>
          </div>
        </div>
      </Card>
      <Card extra="mt-5 max-w-md p-6">
        <h3 className="text-lg font-bold text-navy-700 dark:text-white">Change password</h3>
        <p className="mt-1 text-sm text-gray-600">Enter the current password, then a new one of at least 8 characters.</p>
        <form className="mt-4 space-y-3" onSubmit={savePassword}>
          <label className="block text-sm text-navy-700 dark:text-white">
            Current password
            <input
              type="password"
              autoComplete="current-password"
              className={`${fieldClass} mt-1`}
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
            />
          </label>
          <label className="block text-sm text-navy-700 dark:text-white">
            New password
            <input
              type="password"
              autoComplete="new-password"
              className={`${fieldClass} mt-1`}
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
            />
          </label>
          <label className="block text-sm text-navy-700 dark:text-white">
            Confirm new password
            <input
              type="password"
              autoComplete="new-password"
              className={`${fieldClass} mt-1`}
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
            />
          </label>
          <button
            type="submit"
            disabled={busy}
            className="rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-navy-700 disabled:opacity-50 dark:border-white/10 dark:text-white"
          >
            {busy ? "Saving…" : "Save password"}
          </button>
          {message && <p className="text-sm text-green-600">{message}</p>}
          {error && <p className="text-sm text-red-500">{error}</p>}
        </form>
      </Card>
    </div>
  );
}

export default Profile;
